import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p><strong>Description</strong></p>
     <p>Your station has qualified as a bottom performing station for the number of <strong>Speeding</strong>, On-Road Safety Alerts alerts encountered during the previous week. The intentions of this alert is to spread awareness and additional information at daily standups to DSP’s pertaining to OTR safety, in an effort to reduce unsafe driving within your station and community.</p>
     <p><strong>Station Actions</strong></p>
     <ol>
        <li>Reference the left hand details of the SIM to see which DSPs has high rates of <strong>Speeding</strong> violations</li>
        <li>Reach out to these DSPs to communicate best practices</li>
        <li>Close the exception</li>
     </ol>
     <p><strong>Impact</strong></p>
     <p>On-Road Safety Alerts encourages the OTR leaders to perform stand up communications emphasizing this bottom performing metric and tips on safe driving to reduce the number of alerts and help support improvement to the DSP's scorecard metrics.</p>
     <p><strong>Speeding Safety Tips for DAs:</strong></p>
     <ul>
        <li>As a Professional Driver, you must make the personal commitment to eliminate driving habits not in accordance with professional driver standards, before and during vehicle operation. Safe behavior protects you, your family, and the community.</li>
        <li>There is no acceptable business reason to speed/violate posted speed limits...none.</li>
        <li>If you are unaware of the speed limit, proceed at a speed below what is normal for the type/location of road you are on, until you are able to confirm the posted speed limit.</li>
        <li>Anticipate and adjust in advance of speed reduction areas (work zones, on/off ramps, school zones, lane closures, etc.) and take precaution to not over-accelerate when passing, traveling on on-ramp, changing speed limit zones, etc.</li>
     </ul>
     <p><strong>Best Practices for DSPs</strong></p>
    <ul>
        <li>Use the DSP Safety Dashboard or Netradyne Portal’s Driver page to understand which DAs have the most events.</li>
        <li>Coach DAs on a daily basis using video evidence available in the Netradyne Portal.</li>
        <li>Help DAs to understand the safety impact this provides for them and the communities they drive in.</li>
     </ul>
     <p><strong>Supplemental Links</strong></p>
     <ol>
        <li><span class="wikiinternallink"><a href="https://alchemy.aka.amazon.com/#/site/AMZL/views/ORSADashboard/Volume?:iid=1">ORSA Dashboard</a></span></li>
        <li><span class="wikiinternallink"><a href="https://w.amazon.com/bin/view/Users/shilpkri/new_wiki_page_with_stuff/">On-Road Safety Alerts Wiki</a></span></li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Speeding_Coaching_for_ORSA.jsx